import { AsyncPipe } from '@angular/common'
import { CommonModule } from '@angular/common'
import {
    Component,
    ElementRef,
    HostListener,
    inject,
    signal,
    viewChild,
    ChangeDetectionStrategy,
} from '@angular/core'
import { Router } from '@angular/router'
import { AuthStateService } from '@baboor/baboor-auth'
import { ProfileStateService } from '@baboor/baboor-user'
import { UserSettingsStateService } from '@baboor/baboor-user-setting'
import { UserLoginStatusComponent } from '@baboor/common-components'
import { TextSlicePipe } from '@baboor/common-pipes'
import { WA_LOCATION } from '@ng-web-apis/common'
import { map } from 'rxjs'
@Component({
    selector: 'app-easy-profile-dropdown',
    standalone: true,
    imports: [AsyncPipe, TextSlicePipe, UserLoginStatusComponent, CommonModule],
    templateUrl: './easy-profile-dropdown.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './easy-profile-dropdown.component.css',
})
export class EasyProfileDropdownComponent {
    protected authStateService = inject(AuthStateService)
    protected profileStateService = inject(ProfileStateService)

    private userSettingStateService = inject(UserSettingsStateService)
    private router = inject(Router)
    private readonly location = inject(WA_LOCATION)

    dropdown = viewChild<ElementRef>('dropdown')

    isVisible = signal(false)

    readonly user$ = this.authStateService
        .select('userDetails')
        .pipe(map((userDetails) => userDetails?.user ?? null))

    readonly organization$ = this.authStateService
        .select('userDetails')
        .pipe(map((userDetails) => userDetails?.organization ?? null))

    readonly userFirstName$ = this.user$.pipe(
        map((user) => user?.firstName ?? ''),
    )

    readonly userRole$ = this.authStateService
        .select('userDetails')
        .pipe(
            map((userDetails) =>
                userDetails?.organizationType === 'client'
                    ? ''
                    : userDetails?.role?.name || '',
            ),
        )

    @HostListener('document:click', ['$event'])
    onDocClick(event: MouseEvent) {
        const target = event.target as HTMLElement

        if (
            this.dropdown()?.nativeElement.contains(target) === false &&
            !target.closest('user-login-status')
        ) {
            this.isVisible.set(false)
        }
    }

    onViewDropDown() {
        this.isVisible.update((value) => !value)
    }

    onNavigate(path: string) {
        this.router.navigate([path])

        this.isVisible.set(false)
    }

    logout() {
        this.authStateService.logout()

        this.userSettingStateService.updateSetting('isPinCodeSet', false)

        this.location.assign('/login')
    }
}
